// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-cdb5d250]{text-decoration:none}.padded-container[data-v-cdb5d250]{padding:48px 0 48px 98px}", ""]);
// Exports
module.exports = exports;
